<template>
  <div class="mainBox classifyBox wow animate__animated animate__fadeIn">
    <Loading :visible="loading"></Loading>
    <div v-for="(item, index) in classifyList" :key="index">
      <div class="title" style="text-align: center">
        <div class="text1">{{ item.equipmentType }}</div>
      </div>
      <div class="deviceList">
        <div class="deviceItem maria" v-for="(device, index) in item.bequipments" :key="index"
          @click="navTo('/product/deviceDetail', { id: device.id })">
          <OssImg class="deviceImg" :src="device.equipmentHeaderOssUrl" alt="" />
          <div class="deviceItemInfo">
            <div class="ellipsis">{{ device.equipmentTitle }}</div>
            <div class="ellipsis-multiline" style="-webkit-line-clamp: 2">
              {{ device.equipmentRemark }}
            </div>
          </div>
        </div>
      </div>
      <CommenBtn title="查看更多" @click="showMore(item.id)" style="margin-top: 2rem"></CommenBtn>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import CommenBtn from "@/components/commenBtn.vue";
import { WOW } from "wowjs";
import ProductApi from "@/api/productApi";
import { navTo } from "@/utils/util";
import OssImg from "@/components/ossImg.vue";

const productApi = new ProductApi();
const loading = ref(true)

onMounted(() => {
  const wow = new WOW();
  wow.init();
  getList();
});
const classifyList = ref();

/**
 * 查看更多
 * @param type
 */
const showMore = async (type) => {
  console.log(type);
  navTo("/product/moreDevice", {
    type,
  });
};

/**
 * 获取设备列表
 */
const getList = async () => {
  try {
    let res = await productApi.getDeviceList();
    classifyList.value = res.data || [];
    loading.value = false
  } catch (error) {
    loading.value = false
  }
};
</script>

<style lang="scss" scoped>
.deviceList {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;

  .deviceItem {
    height: 25.25rem;
    border-radius: 1rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .deviceImg {
      width: 100%;
      height: 19.625rem;
      object-fit: contain;
      border-radius: 1rem 1rem 0 0;
    }

    .deviceItemInfo {
      width: 100%;
      flex: 1;
      padding: 1rem;
      box-sizing: border-box;
      text-align: justify;
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 500;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      >div:nth-child(2) {
        color: #888888;
      }
    }
  }
}

.moreBtn {
  width: 7.5625rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem auto 0;
  color: #ffffff;
  font-weight: 500;
  font-size: 1rem;
  background: #32A89E;
  border-radius: 0.5rem;
}

.classifyBox {
  margin-bottom: 3.5rem;
  min-height: 31.25rem;
}

.loadingCl {
  color: var(--primary-color);
}

// @media(max-width: 768px) {
//   .deviceList {
//     grid-template-columns: repeat(2, 1fr);
//     padding: 0 1rem;
//     box-sizing: border-box;
//   }
// }</style>
